import { useEffect, useState } from "react";
import LayoutFilter from "../../../data/LayoutFilter";
import { SelectHook } from "../../../reactHookForm/SelectHook";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import * as S from "./styled";
import LayoutTable from "../../../data/LayoutTable";
import DataTable from "react-data-table-component";
import tableStyleDefaultBolder from "../../../../Services/tableStyleDefaultBolder";
import { paginationOptions } from "../../../data/PagineteInfo";
import CustomLoader from "../../../data/customLoader";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { perfilUsuarioSchema } from "../../../../redux/features/userProfile/schema";
import { AppDispatch, useAppSelector } from "../../../../redux/store";
import { useDispatch } from "react-redux";
import { IListCfops } from "../../../../Pages/Cadastro/CadCfops";
import {
  deleteCfopAsync,
  getCfopAsync,
} from "../../../../redux/features/Cfop/services";
import { notify, notifyError } from "../../../notify/notify-component";
import ModalBootstrap from "../../../data/Modal";
import { normalizeDescricao } from "../../../../utils/normalizeCaracters";
import { InputHook } from "../../../reactHookForm/InputHook";

type FormData = Yup.InferType<typeof perfilUsuarioSchema>;

export function ListCfops({ onEditItem, title, OnAddNewCli }: IListCfops) {
  const dispatch = useDispatch<AppDispatch>();
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);

  const { loading, cfops } = useAppSelector(
    ({ cfopReducer }) => cfopReducer.value,
  );

  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    setValue,
    setError,
    formState,
    formState: { errors },
  } = useForm<FormData>({
    resolver: yupResolver(perfilUsuarioSchema),
  });

  const [modalConfirmation, setModalConfirmation] = useState<boolean>(false);
  const [uuid, setUuid] = useState<string>("");

  const [openFilter, setOpenFilter] = useState<boolean>(false);

  const handleSearchList = (data: any) => {};

  const hanldeAdd = () => {
    OnAddNewCli(true);
  };

  const clearFields = () => {};

  const onClickOpenFilter = () => {
    setOpenFilter(!openFilter);
  };

  const handleEdit = (item: any) => {
    onEditItem(item);
  };

  const handleDelete = (uuid: string) => {
    dispatch(deleteCfopAsync(uuid)).then((result: any) => {
      if (deleteCfopAsync.fulfilled.match(result)) {
        notify("Perfil de acesso excluido.");
        dispatch(getCfopAsync(storeMe?.storeActive?.id));
      } else {
        notifyError("Erro ao excluir perfil de acesso.");
      }
    });
  };

  const columns: any = [
    {
      name: "Codigo",
      selector: (row: any) => row?.cfop,
      sortable: true,
      grow: 0.05,
    },

    {
      name: "Nome",
      selector: (row: any) => normalizeDescricao(row?.descricao_cfop),
      sortable: true,
      grow: 1,
      maxWidth: "800px",
    },

    {
      name: "Ação",
      maxWidth: "90px",
      cell: (row: any) => (
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="tooltip-disabled">Editar</Tooltip>}
          >
            <span className="d-inline-block">
              <Button
                onClick={() => handleEdit(row)}
                variant="contained"
                color="primary"
              >
                <FaEdit size={16} color="8e8d8d" />
              </Button>
            </span>
          </OverlayTrigger>
          <OverlayTrigger
            overlay={<Tooltip id="tooltip-disabled">Excluir</Tooltip>}
          >
            <span className="d-inline-block">
              <Button
                onClick={() => handleModalUuid(row.id)}
                variant="contained"
                color="primary"
              >
                <FaTrash size={14} color="8e8d8d" />
              </Button>
            </span>
          </OverlayTrigger>
        </div>
      ),
      button: true,
    },
  ];

  const handleModalUuid = (uuid: string) => {
    setUuid(uuid);
    setModalConfirmation(true);
  };

  const handleDeleteItem = () => {
    setModalConfirmation(false);
    handleDelete(uuid);
  };

  useEffect(() => {
    dispatch(getCfopAsync(storeMe?.storeActive?.id));
  }, [dispatch]);

  return (
    <>
      <LayoutFilter
        title={title}
        onClickAdd={hanldeAdd}
        onClickClear={clearFields}
        onClickSearch={handleSearchList}
        openFilter={openFilter}
        onClickOpenFilter={onClickOpenFilter}
      >
        <S.Wrapper>
          {openFilter && (
            <div className="min-screen">
              <InputHook
                register={register}
                label="Código"
                name="code"
                placeholder="Código"
                type="text"
              />
              <InputHook
                register={register}
                label="Nome"
                name="name"
                placeholder="Nome"
                type="text"
              />
            </div>
          )}

          <div className="max-screen">
            <InputHook
              register={register}
              label="Código"
              name="code"
              placeholder="Código"
              type="text"
            />
            <InputHook
              register={register}
              label="Nome"
              name="name"
              placeholder="Nome"
              type="text"
            />
          </div>
        </S.Wrapper>
      </LayoutFilter>

      <LayoutTable>
        <DataTable
          columns={columns}
          data={cfops || []}
          striped
          pagination
          paginationDefaultPage={1}
          paginationPerPage={25}
          customStyles={tableStyleDefaultBolder}
          paginationComponentOptions={paginationOptions}
          progressPending={loading}
          progressComponent={<CustomLoader />}
          noDataComponent="Nenhuma informação foi encontrada."
        />
      </LayoutTable>

      <ModalBootstrap
        state={modalConfirmation}
        setState={setModalConfirmation}
        text={"Certeza que deseja excluir?"}
        handleAction={handleDeleteItem}
      />
    </>
  );
}
